import { render, staticRenderFns } from "./TempSpuShopIdsField.vue?vue&type=template&id=45aed01d&scoped=true"
import script from "./TempSpuShopIdsField.vue?vue&type=script&lang=ts"
export * from "./TempSpuShopIdsField.vue?vue&type=script&lang=ts"
import style0 from "./TempSpuShopIdsField.vue?vue&type=style&index=0&id=45aed01d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aed01d",
  null
  
)

export default component.exports